<template>
  <Navbar />
  <main id="main-content">
    <slot />
  </main>
  <Footer />
</template>

<script setup>
import Navbar from "~/components/Navbar.vue";

const config = useRuntimeConfig();
useHead({
  script: [
    {
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Travvir",
        url: config.public.baseUrl,
        foundingDate: "2021",
        founders: [
          {
            "@type": "Person",
            name: "Rohan mittal",
          },
        ],
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer support",
          telephone: "*********",
          email: "rohan@travvir.com",
        },
        sameAs: [
          "https://www.instagram.com/travvir",
          "https://www.linkedin.com/company/travvir/",
          "https://x.com/Travvir_AI",
        ],
      }),
    },
  ],
});
</script>

<style lang="scss" scoped></style>
